"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./UploadField.css");

require("regenerator-runtime/runtime");

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Our main component
var UploadField = /*#__PURE__*/function (_Component) {
  _inherits(UploadField, _Component);

  var _super = _createSuper(UploadField);

  function UploadField(props) {
    var _this;

    _classCallCheck(this, UploadField);

    _this = _super.call(this, props);
    _this.state = {
      base_example: '',
      // acceptedFileTypes: 'image/jpg, image/jpeg, image/png',
      uploadError: false,
      upload_message: '',
      files: []
    };
    return _this;
  }

  _createClass(UploadField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.reset();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          maxSize = _this$props.maxSize,
          multiple = _this$props.multiple,
          type = _this$props.type;
      if (maxSize !== prevProps.maxSize || multiple !== prevProps.multiple || type !== prevProps.type) this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      var type = this.props.type;
      this.setState({
        base_example: '',
        // acceptedFileTypes : 
        //     type === 'image' ? 'image/jpg, image/jpeg, image/png' 
        //     : type === 'video' ? 'video/mp4'
        //     :  '/*',
        uploadError: false,
        upload_message: ''
      });
    } // Before uploading, check if the file can be accepted

  }, {
    key: "verifyFile",
    value: function verifyFile(acceptedFiles) {
      var _this$props$maxSize = this.props.maxSize,
          maxSize = _this$props$maxSize === void 0 ? 500000000 : _this$props$maxSize;

      if (acceptedFiles && acceptedFiles.length > 0) {
        var currentFile = acceptedFiles[0],
            currentFileType = currentFile.type,
            currentFileSize = currentFile.size;

        if (currentFileSize > maxSize) {
          this.setState({
            uploadError: true,
            upload_message: 'Image too big'
          });
          return false; // } else if (!this.state.acceptedFileTypes.includes(currentFileType)) {
          //     this.setState({ uploadError: true, upload_message: 'This file type is not allowed' })
          //     return false
        } else return true;
      }
    }
  }, {
    key: "onDrop",
    value: function () {
      var _onDrop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(acceptedFiles, rejectedFiles) {
        var _this$props2, getBase64, maxUpload, onChange, isVerified, base64conversion, toBase64, i, conversion;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = this.props, getBase64 = _this$props2.getBase64, maxUpload = _this$props2.maxUpload, onChange = _this$props2.onChange;
                this.reset(); // When we upload our image or video, we first need to check if the file can be accepted

                if (rejectedFiles && rejectedFiles.length > 0) this.verifyFile(rejectedFiles);

                if (!(acceptedFiles.length > maxUpload)) {
                  _context.next = 7;
                  break;
                }

                this.setState({
                  uploadError: true,
                  upload_message: 'Max is ' + maxUpload
                });
                _context.next = 25;
                break;

              case 7:
                if (!(acceptedFiles && acceptedFiles.length > 0)) {
                  _context.next = 25;
                  break;
                }

                isVerified = this.verifyFile(acceptedFiles);

                if (!isVerified) {
                  _context.next = 25;
                  break;
                }

                this.setState({
                  upload_message: "".concat(acceptedFiles.length, " files for upload"),
                  upload_files_length: acceptedFiles.length
                });
                base64conversion = [];

                toBase64 = function toBase64(file) {
                  return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);

                    reader.onload = function () {
                      return resolve(reader.result);
                    };

                    reader.onerror = function (error) {
                      return reject(error);
                    };
                  });
                };

                if (!getBase64) {
                  _context.next = 23;
                  break;
                }

                i = 0;

              case 15:
                if (!(i < acceptedFiles.length)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return toBase64(acceptedFiles[i]);

              case 18:
                conversion = _context.sent;
                base64conversion.push({
                  fileName: acceptedFiles[i].name.replace(/_|-/gi, ' ').replace(/.jpeg|.jpg|.png/gi, ''),
                  fileResult: conversion
                });

              case 20:
                i++;
                _context.next = 15;
                break;

              case 23:
                getBase64 && getBase64(base64conversion);
                onChange && onChange(acceptedFiles);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDrop(_x, _x2) {
        return _onDrop.apply(this, arguments);
      }

      return onDrop;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          _this$props3$maxSize = _this$props3.maxSize,
          maxSize = _this$props3$maxSize === void 0 ? 500000000 : _this$props3$maxSize,
          _this$props3$multiple = _this$props3.multiple,
          multiple = _this$props3$multiple === void 0 ? false : _this$props3$multiple,
          show_example = _this$props3.show_example,
          _this$props3$type = _this$props3.type,
          type = _this$props3$type === void 0 ? 'image' : _this$props3$type,
          user_message = _this$props3.user_message,
          label = _this$props3.label,
          noError = _this$props3.noError,
          _this$state = this.state,
          acceptedFileTypes = _this$state.acceptedFileTypes,
          base_example = _this$state.base_example,
          uploadError = _this$state.uploadError,
          upload_message = _this$state.upload_message;
      return /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
        accept: acceptedFileTypes,
        maxSize: maxSize,
        multiple: multiple,
        onDrop: this.onDrop.bind(this)
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps,
            isDragActive = _ref.isDragActive;
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, getRootProps(), {
          className: ['uploadField', isDragActive ? 'active' : undefined, upload_message && noError ? 'message' : undefined, uploadError ? 'uploadFieldError' : undefined].join(' '),
          style: {
            borderRadius: show_example ? base_example ? '5px' : '25px' : '25px',
            height: show_example ? base_example ? '100px' : '40px' : '40px'
          }
        }), /*#__PURE__*/_react["default"].createElement("input", _extends({}, getInputProps(), {
          onClick: function onClick() {
            return _this2.reset();
          },
          "aria-label": label
        })), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          className: "upload_icon",
          name: "Upload"
        }), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          className: "error_icon",
          name: "Close"
        }), show_example ? base_example ? type === 'image' ? /*#__PURE__*/_react["default"].createElement("img", {
          src: base_example.fileResult,
          alt: base_example.fileName
        }) : type === 'video' && /*#__PURE__*/_react["default"].createElement("video", {
          controls: true
        }, /*#__PURE__*/_react["default"].createElement("source", {
          src: base_example.fileResult,
          type: "video/mp4"
        })) : /*#__PURE__*/_react["default"].createElement("div", {
          className: "uploadFieldMessage",
          style: {
            opacity: upload_message && noError ? 1 : 0
          }
        }, upload_message) : /*#__PURE__*/_react["default"].createElement("div", {
          className: "uploadFieldMessage",
          style: {
            opacity: upload_message && noError ? 1 : 0
          }
        }, upload_message), user_message && /*#__PURE__*/_react["default"].createElement("div", {
          className: "uploadFieldUserMessage"
        }, user_message));
      });
    }
  }]);

  return UploadField;
}(_react.Component);

exports["default"] = UploadField;